<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JgGHuz/tc-custom/9781540260024.jpg?1735701614774" alt="This image is the cover for the book Boston Marathon Traditions & Lore, Sports"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Boston Marathon Traditions & Lore, Sports
      </h1>
      <p class="bookDescription body article font2">
        <p>First run in 1897 as America's second and the world's fourth, the Boston Marathon attracts thousands thanks to its long and unique history. What began as simple start and finish lines has grown to encompass a lavish colorful artistry. An athlete and cultural exchange program with the Ohme-Hochi 30K in Japan started with four-time winner Bill Rodgers in the 1970s. Artist Bobbi Gibb was the first female finisher of the race in 1966, and she was later asked to create her own statute along the route to commemorate the event.  Author Paul C. Clerici explores the history and iconic traditions of America's most famous road race.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul C. Clerici, Guy Morse III
      </h2>
      
      <p class="authorDescription body article">Paul C. Clerici is the bestselling author of Born to Coach: The Story of Bill Squires, the Legendary Coach of the Greatest Generation of American Distance Runners (Meyer + Meyer Sport Publishers), Oregon Running Legend Steve Prefontaine: In the Footsteps of the U.S. Olympic Athlete, Activist and Icon (The History Press), Images of Modern America: The Boston Marathon (THP), A History of the Falmouth Road Race: Running Cape Cod (THP), Boston Marathon History by the Mile (THP), Journey of the Boston Marathon (Cheers Publishing, China) and History of the Greater Boston Track Club (THP). He is a journalist, public speaker, media guest, documentary film contributor, writer, photographer and former newspaper editor and sports editor. Race director of the Camy 5K Run & David 5K Walk, he has competed in nearly every distance from the mile to the marathon--including two triathlons and forty-three marathons (the Boston Marathon twenty-three years in a row)--and has won several running age group and Clydesdale awards.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9f386856